import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter"
import * as moment from 'moment';
import { Injectable } from "@angular/core";
import { DateFormatService } from './services/date-format.service'

@Injectable()
export class DateFormat extends MomentDateAdapter {

    constructor(private dateFormatService:DateFormatService){
        super('en-US'); // set default locale
    }

    public format(date: moment.Moment, displayFormat: string): string
    {
        const locale = this.dateFormatService.getLocale();
        const format = this.dateFormatService.getFormat();

        return date.locale(locale).format(format);
    }

//    format(date: Date, displayFormat: Object): string {
//         // moment.locale('ru-RU'); // Choose the locale
//         var formatString = (displayFormat === 'input')? 'DD.MM.YYYY' : 'LLL';
//         return moment(date).format(formatString);
//     }
}



// export const APP_DATE_FORMATS =
// {
//    parse: {
//        dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
//    },
//    display: {
//        dateInput: 'input',
//        monthYearLabel: { year: 'numeric', month: 'numeric' },
//        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
//        monthYearA11yLabel: {year: 'numeric', month: 'long'},
//    }
// }